import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const ArchiveCompanyModal = ({ open, onClose, onConfirm, company }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Archive Company</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to archive{" "}
          <strong>{company?.tradingName || company?.legalName}</strong>? This
          action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveCompanyModal;